import {connect, useDispatch} from 'react-redux'
import React, {Children, cloneElement, isValidElement} from "react";

const mapStateToProps = (state, ownProps) => {
  const {isLoading, isLoadingText, isLoadingAmount} = state.app;
  const {user, profile} = state.auth;
  return {
    logged: state.auth.user !== null,
    user,
    profile,
    isLoading,
    isLoadingText,
    isLoadingAmount,
  }
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
};
const WebView = (props) => {
  let dispatch = useDispatch();
  const childrenWithProps = Children.map(props.children, child => {
    if (isValidElement(child)) {
      const newProps = {
        dispatch: dispatch,
      }
      return cloneElement(child, {...newProps})
    }
    return child;
  });
  return (
    <div className="App page webview container-fluid">
      {childrenWithProps}
    </div>
  )
}

const WebViewContainer = connect(mapStateToProps, mapDispatchToProps)(WebView);

export default WebViewContainer
